import React from 'react';
import PropTypes from 'prop-types';
import TopBar from '../TopBar';

export default function ObjectTopBar({
  title = 'Default Title',
  primaryBtn = {},
  extra,
}) {
  const {
    btnText = 'Click Me',
    btnIcon = 'bi-plus-lg',
    onClick,
    variant = 'primary',
    disabled = false,
  } = primaryBtn;

  return (
    <TopBar>
      <h5 className="mb-0 fw-semibold">{title}</h5>

      <div className="d-flex align-items-center gap-2">
        {extra}
        {onClick && (
          <button
            onClick={onClick}
            className={`btn btn-sm btn-${variant} d-flex align-items-center gap-1`}
            disabled={disabled}
          >
            <i className={`bi ${btnIcon}`} />
            {btnText}
          </button>
        )}
      </div>
    </TopBar>
  );
}

ObjectTopBar.propTypes = {
  title: PropTypes.string,
  primaryBtn: PropTypes.shape({
    btnText: PropTypes.string,
    btnIcon: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
  }),
  extra: PropTypes.node,
};
